import axios from "../utils/axios";

export default function fetchOrdersCount(adminId) {
  return axios.get("/admin/" + adminId + "/orders/count");
}
